{
  "fr": {
    "startPage": {
      "collections": {
        "timedLabel": "S'inscrire maintenant",
        "timedTitle": "Calendrier de l'Avent gratuit avec 24 inspirations"
      },
      "ctaBanner": {
        "aiDSGVOCompliant": {
          "checklist": {
            "1": "Accès élèves au Chat IA, Chatbot jeu de rôle, Chat PDF, Génération d'images, Éditeur de texte et Outil multimédia IA",
            "2": "Aucune inscription de vos élèves nécessaire",
            "3": "Suppression automatique après 24 heures<br><a href=\"{href}\" target=\"_blank\">En savoir plus</a>"
          },
          "text": "Avec les salles de classe fobizz, vos élèves obtiennent leur propre accès à l'<b>assistance IA fobizz</b> et peuvent travailler <b>conformément au RGPD</b>.",
          "title": "Salles de classe : Utiliser l'assistance IA conforme au RGPD avec les élèves"
        },
        "simpleAndSecure": {
          "checklist": {
            "1": "Simple & sécurisé",
            "2": "Conforme au RGPD",
            "3": "Innovant : les outils les plus récents pour rendre l'enseignement encore meilleur et plus varié"
          },
          "subline": "Assistance IA fobizz pour une planification encore plus rapide",
          "sublinePrefix": "Incl. IA",
          "text": "Tous les outils utiles pour la planification et la réalisation des cours en un seul endroit.",
          "title": "Concevoir un enseignement numérique de manière simple et sécurisée"
        },
        "startFree": "Commencer gratuitement maintenant"
      },
      "headers": {
        "assistants": "Assistants IA recommandés",
        "assistantsBadge": "150+ Chatbots",
        "continueWorkshops": "Continuer",
        "pinnedTools": "Outils épinglés",
        "miniTools": "Prompts populaires",
        "miniToolsBadge": "55+ Prompts",
        "myAssistants": "Mes assistants",
        "newAssistants": "Nouveaux assistants",
        "recommendationsForYou": "Recommandations pour vous",
        "recommendedWorkshops": "Recommandations pour vous",
        "savedCourses": "Cours enregistrés",
        "savedMaterial": "Matériel enregistré",
        "sectionChatTools": "Chat IA et assistants",
        "sectionFeedbackTools": "Feedback et évaluation IA",
        "sectionMaterialTools": "Créer du matériel",
        "sectionMaterials": "Utiliser du matériel pédagogique",
        "sectionMultimediaTools": "Outils multimédia IA",
        "sectionOnboarding": "Votre entrée dans fobizz",
        "sectionShareTools": "Partager du contenu en toute sécurité",
        "sectionWorkshops": "Découvrir les formations",
        "videoOnboarding": "fobizz en 100 secondes",
        "yourWorkshops": "Webinaires en direct et ateliers actuels"
      },
      "hiddenFeedbackTools": {
        "badge": "Où sont les outils ?",
        "tooltip": "Ces outils sont masqués par défaut et peuvent être activés au niveau de l'école sur demande."
      },
      "howTo": {
        "bookmarkTeaserHeadline": "Enregistrer les cours et contenus pour plus tard",
        "bookmarkTeaserLinkCourses": "Liste de souhaits des formations",
        "bookmarkTeaserLinkMaterial": "Liste de souhaits du matériel",
        "bookmarkTeaserText": "Enregistrez les formations et le matériel en cliquant sur le cœur et retrouvez-les facilement dans votre liste de souhaits.",
        "materialTeaserHeadline": "Partager, c'est prendre soin : Utiliser le matériel ensemble",
        "materialTeaserLink": "Voir le tutoriel",
        "materialTeaserText": "Tout le matériel est sous licence CC-BY. Par remix, vous pouvez le copier gratuitement, l'adapter pour vous et le réutiliser.",
        "materialTeaserTextCommunity": "Tout le matériel est sous licence CC-BY. Vous pouvez le copier et l'adapter gratuitement via Remix. Veuillez vérifier de manière critique le contenu et les liens au préalable, notamment en ce qui concerne les droits d'auteur et la protection des données.",
        "materialTeaserVideoId": "1085940798",
        "materialTeaserVideoTitle": "Créer et partager du matériel"
      },
      "links": {
        "assistantsCatalog": "Tous les assistants",
        "createClass": "Créer une salle de classe",
        "hideOnboarding": "Masquer l'entrée dans fobizz",
        "miniToolsCatalog": "Plus d'idées dans le laboratoire de prompts",
        "toAssistantsCatalog": "Tout afficher",
        "toMaterials": "Tout afficher",
        "toMyAssistantsCatalog": "Tout afficher",
        "toSavedMaterials": "Votre liste de souhaits",
        "toSavedWorkshops": "Votre liste de souhaits",
        "toTools": "Afficher tous les outils",
        "toWorkshops": "Toutes les formations",
        "watchTutorial": "Voir le tutoriel"
      },
      "onboarding": {
        "videoId": "1085940572",
        "videoTitle": "fobizz en 100 secondes"
      },
      "paragraphs": {
        "mySchoolClassesDisabled": "Les salles de classe sont désactivées pour votre groupe de licence. Veuillez contacter la personne qui gère la licence pour plus d'informations.",
        "onboarding": "Découvrez vos possibilités chez fobizz - court et concis, comme une introduction compacte ou commencez directement avec votre premier cours.",
        "recommendationsAndProfile": "Ces paramètres seront également appliqués à votre <a href=\"{href}\" target=\"_blank\">profil</a>.",
        "recommendationsForYou": "Nous vous recommandons des contenus basés sur vos paramètres de profil et vos cours ou matériels déjà suivis ou enregistrés."
      },
      "schoolClasses": {
        "videoId": "1085940985",
        "videoTitle": "Salles de classe fobizz en 30 secondes"
      },
      "toolTips": {
        "recommendationsForYou": "Ici, vous pouvez définir les sujets pour lesquels des recommandations vous seront affichées"
      },
      "tools": {
        "experimental": "Expérimental",
        "headers": {
          "title": "Utilisez des outils utiles renforcés par IA",
          "subtitle": "Avec quoi souhaitez-vous travailler aujourd'hui ?"
        },
        "pin": "Épingler « {name} »",
        "pinnedAnnouncement": "« {name} » se trouve maintenant dans « Outils épinglés ».",
        "pinnedTeaser": "Tes outils favoris s'afficheront ici dès que tu les épingleras. Tu pourras ainsi y accéder rapidement.",
        "unpinnedAnnouncement": "« {name} » ne se trouve plus dans « Outils épinglés »."
      },
      "webinar": {
        "accessLinkLater": "Le lien d'accès apparaîtra ici plus tard",
        "certificateLater": "Votre certificat apparaîtra ici plus tard",
        "enrolled": "Inscrit",
        "participated": "Participé",
        "percentComplete": "{percent}% terminé",
        "reserveSpot": "Réserver une place maintenant",
        "toCertificate": "Vers le certificat",
        "toLiveWebinar": "Vers le webinaire en direct"
      }
    }
  }
}
